import React from 'react';
import PropTypes from 'prop-types';
import {Col, Form, Select as AntdSelect} from "antd";
import ListWrapper from "../../../../Rules/List/ListWrapper";
import Text from "../../../../../../../components/form/Text/Text";
import Types from "../../../../../../General/Types";
import DropDownMultiSelect from "./DropDownMultiSelect";

@autobind
/**
 *
 * @class ListWrapper
 * @extends PureComponen
 */
export default class AddColumns extends React.PureComponent {
    static propTypes = {
        label: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        required: PropTypes.bool,
        meta: PropTypes.object,
        validateStatus: PropTypes.oneOf([
            'success', 'warning', 'error', 'validating',
        ]),
        defaultValue: PropTypes.array,
        size: PropTypes.string,
        disabled: PropTypes.bool,
        addonBefore: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        addonAfter: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.node,
        ]),
        onPressEnter: PropTypes.func,
        autosize: PropTypes.oneOfType([
            PropTypes.bool,
            PropTypes.shape({
                minRows: PropTypes.number,
                maxRows: PropTypes.number,
            }),
        ]),
        input: PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.oneOfType([ PropTypes.string , PropTypes.arrayOf( PropTypes.shape({
                    name: PropTypes.string,
                    factors: PropTypes.object,
                    factorUnit: PropTypes.string,
                }))
            ]),
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
        }),
        rest: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
    };

    static defaultProps = {
        label: undefined,
        validateStatus: undefined,
        required: false,
        input: {},
        disabled: false,
    };


    constructor(props) {
        super(props);
        this.state={
            types : Types.items('WorkingHour.Rules'),
            items: props.input && props.input.value || [],
        }
    }


    /**
     *
     */
    componentWillMount() {
        super.componentWillMount();

        const {input, defaultValue} = this.props;

        input.onChange(defaultValue);
    }


    /**
     *
     * @return {String}
     * @private
     */
    _validateStatus() {
        const {disabled, required, validateStatus, input, meta} = this.props;
        let _status = validateStatus;

        if (!disabled) {
            if (meta.asyncValidating) {
                _status = 'validating';
            } else if (meta.touched) {
                if (meta.error) {
                    _status = 'error';
                } else {
                    if (!required && app._.isEmpty(input.value)) {
                        _status = 'warning';
                    } else if (meta.valid) {
                        _status = 'success';
                    }
                }
            }
        }

        return _status;
    }

    onChange= (newValue)=>{
        let {input} = this.props;
        input.onChange(newValue);
    }

    updateColumns = (index, key, newValue)=>{
        let {items } = this.state;
        let newItems = [...items]
        newItems[index][key] = newValue;
        this.setState({items: newItems}, ()=>{
            this.onChange(newItems)
        })
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.input !== this.props.input){
            this.setState({items: this.props.input && this.props.input.value || []})
        }
    }

    renderRow = (item, index)=>{
        return <div key={index}>
            <Col md={8}>
                <label>عنوان ستون :</label>
                <Text
                    value={item.name}
                    onChange={(e)=> {
                        this.updateColumns(index, 'name', e.target.value )
                    }}
                    name={'name'}
                />
            </Col>

            <Col md={12}>
                <label>
                    {'ضرایب :'}
                </label>
                <DropDownMultiSelect
                    defaultValue={Object.values(item.factors)}
                    onChange={(newFactors)=>{
                        this.updateColumns(index, 'factors', newFactors )
                    }}
                />
            </Col>

            <Col md={4}>
                <label>{app.translate('routes.home.attendance.reports.Report factor_column_types')}</label>
                <AntdSelect
                    defaultValue={item.factorUnit}
                    onChange={(e)=>{
                        this.updateColumns(index, 'factor_unit' , e)
                    }}
                >
                    <AntdSelect.Option value="minute">{app.translate('routes.home.attendance.reports.Report minute_base')}</AntdSelect.Option>
                    <AntdSelect.Option value="hour">{app.translate('routes.home.attendance.reports.Report hour_base')}</AntdSelect.Option>
                    <AntdSelect.Option value="day">{app.translate('routes.home.attendance.reports.Report one_day_base')}</AntdSelect.Option>
                </AntdSelect>
            </Col>

        </div>
    }
    /**
     *
     * @return {XML}
     */
    render() {
        const {
            input, defaultValue, size, onPressEnter, addonBefore,
            addonAfter, disabled, label, required, validateStatus,
            meta, ...rest
        } = this.props;

        let {items} = this.state;

        return (
            <Form.Item
                label={label}
                help={meta.touched && meta.error}
                required={required}
                validateStatus={this._validateStatus()}
                hasFeedback
            >
                {items && items.length > 0 &&
                    items.map((item, index)=>{
                        return this.renderRow(item, index)
                    })
                }

                <div
                    style={{
                        float: 'left',
                        paddingTop: '0.3em',
                    }}
                >
                    <button className={'ant-btn ant-btn-primary'}
                        onClick={()=>{
                            if(items.length< 50){
                                let newItems = [...items]
                                newItems.push({name: '', factors: {} , factorUnit: 'minute'})
                                this.setState({items: newItems});
                            }
                        }}
                    >
                        {app.translate('افزودن ستون')}
                    </button>
                </div>

            </Form.Item>
        );
    }
}
